export default `
  query amBlogPosts($page: Int) {
    amBlogPosts(
       type: ALL
       page: $page
       ) {
       all_post_size
       items {
          post_id
          updated: updated_at
          title
          url_key
          list_thumbnail
          short_content
       }
   }
}
`;
